//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as axios from "@/store/http";
import SelectListSearch from "@/pccomponents/SelectListSearch"

export default {
  name:'SelectListInfo',
  components: {
    SelectListSearch
  },
  props:{
    // 弹窗按钮名称
    btnName:{
      type:String,
      default:''
    },
    // 没有清空按钮
    noDelete:{
      type:Boolean,
      default:false
    },
    // sys_cselectpub表的selectwintype字段、公用选择框ID(配置选择框名称)
    selectWinType:{
      type:String,
      default:''
    },
    // 行项列表选择的形式：单选radio、多选checkbox
    selectType:{
      type:String,
      default:'radio'
    },
    // 传递的所用变量(对应数据库中配置的defcond的参数 多值用@@@隔开)
    defparas:{
      type:String,
      default:''
    },
    // 当前行项的index
    rowindex:{
      type: Number,
      default: -1
    },
    // 回调函数
    callbackFun:{
      type:Function,
      default:null
    },
    // 点击确认前函数
    befsubmit:{
      type:Function,
      default:null
    },
    // 弹出框所需数据
    bindData:{
      type:Object,
      default: () => ({})
    },
    // 编辑项
    editItem:{
      type:String,
      default:''
    },
    // 匹配的编辑项
    matchItem:{
      type:String,
      default:''
    },
    // 清空的图标
    clearIcon: {
      type: String,
      default: "el-icon-close"
    },
    // 打开选择的图标
    openIcon: {
      type: String,
      default: "el-icon-files"
    },
    // 是否隐藏按钮的内容
    hideSpan: {
      type: Boolean,
      default: true
    },
    // 输入框是否有值，有值才显示清除值的按钮
    hasVal: {
        type: String,
        default: ""
    },
    // 返回类型默认为'0'，
    //为'0'时，提交时，会将sysid传入后台，重新从表中查询并获取所需返回的参数
    //为'1'时，提交时，会直接返回当前列表的所选值
    //为'2'时，将在确认选择后，从后台再次获取sys_cselectpub表中的returnsqlname字段的查询值
    //为'3'时，不再去后台查询数据，直接返回当前选择项的数据
    returnType:{
      type:String,
      default:'0'
    },
    // 页面传入的查询条件和值(传递的查询条件 格式：fieldname:fieldvalue  多个条件用@@@隔开，fieldvalue多值用,隔开。)
    // 使用in的范例 传参:
    //STOREREGIONID not in:AAA,BBB,...
    //STOREREGIONID in:AAA,BBB,...
    cond:{
      type:String,
      default:''
    },
    // 页面传入的查询条件和值
    sysid:{
      type:String,
      default:process.env.API_LOGIN_ROOT
    },
    //打开弹出框前执行
    beforeOpenSelect:{
      type:Function,
      require: false
    },
    flowsysid:{
      type:String,
      default:''
    },
    beforeOpenSetCond:{
      type:Function,
      default:null
    },
    // 配合后台condclass字段传的参数
    condclassparams:{
      type:String,
      default:''
    },
    passtoken:{
      type:Boolean,
      default:false
    },  
    nodatatips:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      dialogVisible: false,//控制弹出框的显示
      pagecond: {},//存储当前查询内容
      selectdata:[],//存储已选信息
      returnData:[],//用于保存向父组件返回同步数据
      configParams:[],//用于定义向父组件返回同步数据的信息字段名
      selectid:'',//保存所选的项的id

      pageinfo: {
        currPage: 0, //当前页码
        rowsPerPage: 10, //每页展示数量
        count: 0 //记录总数
      }, //分页信息

      //存储传入的值
      vSelectWinType:this.selectWinType,
      vSelectType:this.selectType,
      vDefparas:this.defparas,
      vbindData:this.bindData,
      vcond:this.cond,
      vsysid:this.sysid
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    /**
     * 初始化数据
     */
    async initData(){
      let isSuccess = false;

      let url = "selectPubController/getSelectPub";
      let params = {
        selectwintype:this.vSelectWinType,
        selecttype:this.vSelectType,
        defparas:this.vDefparas,
        cond:this.vcond,
        sysid:this.vsysid,
        pageinfo:this.pageinfo,
        pagecond:this.pagecond,//查询
        flowsysid:this.flowsysid,
        condclassparams:this.condclassparams,
        t_params:this.passtoken == true?"1":""
      };
      //后台公用弹出框测试,可查出弹出框所需数据
      await axios.post(url,params).then(({ data })=>{

        // this.$set(this, 'vbindData', data.data);
        // this.$set(this, 'configParams', [...data.data.configinfo.selectfield.split(',')]);
		    this.vbindData=data.data;
        this.configParams=[...data.data.configinfo.selectfield.split(',')]

        //设置分页信息
        this.pageinfo.currPage = data.data.pageinfo.current;
        this.pageinfo.rowsPerPage = data.data.pageinfo.length;
        this.pageinfo.count = data.data.pageinfo.count;

        isSuccess=true;
        // this.keepSelectState();

        if(!this.dialogVisible){
          this.dialogVisible=true;
        }
      });

      return isSuccess;
    },
    /**
     * 初始化字段信息数据
     */
    async initConfigParams(){
      let isSuccess = false;
      let url = "selectPubController/getSelectPub";
      let params = {
        selectwintype:this.vSelectWinType,
        selecttype:this.vSelectType,
        defparas:this.vDefparas,
        cond:this.vcond,
        sysid:this.vsysid,
        pageinfo:this.pageinfo,
        pagecond:this.pagecond,//查询
        flowsysid:this.flowsysid,
        t_params:this.passtoken == true?"1":""
      };
      //后台公用弹出框测试,可查出弹出框所需数据
      await axios.post(url,params).then(({ data })=>{ 
		  this.vbindData=data.data;
        this.configParams=[...data.data.configinfo.selectfield.split(',')];
        isSuccess=true;
      });
      return isSuccess;
    },
    /**
     * 公用页面切换方法
     */
    PageChange(oPage) {
      this.pageinfo.currPage = oPage.page_index;
      this.pageinfo.rowsPerPage = oPage.page_limit;
      // this.initData();
      this.initData().then((result)=>{
        if (result) {
          this.keepSelectState();
        }else {
          console.log('2019年12月31日17:20:12 SelectListInfo.vue[初始化失败]——[null] :',null);
        }
      });
    },
    /**
     * 保存选中的数据id,row-key就是要指定一个key标识这一行的数据
     */
    getRowKey (row) {
      return row[this.vbindData.configinfo.selectid];
    },
    /**
     * 打开选择框
     */
    openSelectData(){
      this.resetQuery();
      let flag = true;
      try {
          flag = this.beforeOpenSelect(this.rowindex);
      } catch (error) {
          flag = true;
      }
      let vCond=this.cond;
      if(this.beforeOpenSetCond){
        vCond=this.beforeOpenSetCond();
      }
      if(flag){
        //存储传入的值
        this.vSelectWinType=this.selectWinType;
        this.vSelectType=this.selectType;
        this.vDefparas=this.defparas;
        this.vbindData=this.bindData;
        this.vcond=vCond;

        //当传入bindData时，初始化所需值
        if(Object.keys(this.vbindData).length!=0){
          this.vSelectWinType=this.vbindData.selectwintype;
          this.vSelectType=this.vbindData.selecttype;
          this.vDefparas=this.vbindData.defparas;
          // this.cond=this.vbindData.cond;
        }
        // this.initData();
        this.initData().then((result)=>{
          if (result) {
            this.keepSelectState();
          }else {
            console.log('2019年12月31日17:20:12 SelectListInfo.vue[初始化失败]——[null] :',null);
          }
        });
      }
    },
    /**
     * 点击确认前执行
     */
    async beforeSubmitSelectData(){
      if(this.returnType=='3'){
        this.returnData=this.selectdata;
        for(let showinfo of this.vbindData.showinfo){
          this.configParams.push(showinfo['FIELD']);
        }
      }else{
        let msg='';
        let selectid=this.selectid.toString();

        //selectid为空时置为-1，使其查不出值
        if(selectid==''){
          selectid='-1';
        }

        let url = "selectPubController/getSelectPubReturn";
        let params = {
          selectwintype:this.vSelectWinType,
          selecttype:this.vSelectType,
          returntype:this.returnType,
          defparas:this.vDefparas,
          selectid:selectid,
          cond:'',
          sysid:this.vsysid,
          flowsysid:this.flowsysid,
          condclassparams:this.condclassparams,
          t_params:this.passtoken == true?"1":""
        };
        await this.axios.post(url,params).then(({ data })=>{
          if(data.code=='1'){

            //如果returnType==1,会将 后台查出数据(data.data.returndata) 与 已选的数据(this.selectdata) 合并
            if(this.returnType=='1'){
              if(data.data.returndata&&data.data.returndata.length!=0){
                for(let i=0;i<data.data.returndata.length;i++){
                  for(let property in data.data.returndata[i]){
                    //将对象的属性进行替换，保证通过id查出的name数据可以直接返回
                    if(this.isNotNullOrEmpty(this.selectdata[i][property])){
                      data.data.returndata[i][property]=this.selectdata[i][property];
                    }
                  }
                }
              }
            }

            if(this.befsubmit){
              //确认前校验函数
              let params = {
                rowindex : this.rowindex,
                returnData :data.data.returndata
              }
              msg=this.befsubmit(params,this.vbindData.configinfo.selectid);
            }
            if(msg==''){
              this.returnData=data.data.returndata;//回填的数据
            }else{
              this.$notify({
              title: this.$t('common.warning'),
              message: msg,
              type: 'warning'
              });
            }
          }else{
            console.log('2019年11月22日09:00:33 SelectListInfo.vue[查询失败]——[null] :',null);
          }
        }).catch(function(error){
          console.log(error)//错误处理 相当于error
        })
      }
    },
    /**
     * 点击确认，回写信息到表单
     */
    submitSelectData() {
      this.beforeSubmitSelectData().then(()=>{
        if(this.callbackFun){
          //有回调函数，传入的同步数据是对象时使用
          let params = {
              rowindex : this.rowindex,
              returnData : this.returnData,
               flowsysid:this.flowsysid
          }
          this.callbackFun(params,this.vbindData.configinfo.selectid);
        }else{
          //没有回调函数，传入的同步数据是字符串时使用
          for(let configParam of this.configParams){
              let echoData='';
              for(let dataCollect of this.returnData){
                if(echoData==''){
                  echoData=dataCollect[configParam];
                }else{
                  echoData=echoData+';'+dataCollect[configParam];
                }
              }
              
              this.$emit('update:'+configParam, echoData);
          }
        }
        this.dialogVisible = false;
        // 清空已选的节点状态
        this.$refs['selectListTable'].clearSelection();
        this.selectid='';
        this.selectdata.length=0;
        this.vbindData.querydata=[];
      });
    },
    /**
     * 点击清空
     */
    clearSelectData : async function(){
      //清空回填的数据
      if(this.callbackFun){
        //有回调函数，传入的同步数据是对象时使用
        let returnData=[];
        let obj={};
        if(this.configParams.length > 0){
          for(let i=0;i<this.configParams.length;i++){
              obj[this.configParams[i]] = '';
          }
        }else {
          await this.initConfigParams().then((result)=>{
            if (result) {
              for(let i=0;i<this.configParams.length;i++){
                obj[this.configParams[i]] = '';
              }
            }else {
              console.log('2019年12月31日17:20:12 SelectListInfo.vue[初始化失败]——[null] :',null);
            }
          });
        }
        returnData.push(obj);
        let params = {
            type : "clear",
            rowindex : this.rowindex,
            returnData : returnData
        }
        this.callbackFun(params);
      }else{
        //没有回调函数，传入的同步数据是字符串时使用
        if(this.configParams.length > 0){
          for(let configParam of this.configParams){
              this.$emit('update:'+configParam, '')
          }
        }else{
          for (let sKey in this.$attrs) {
            this.$emit("update:" + sKey, "");
          }
        }
      }

      // 清空已选的节点状态
      this.$refs['selectListTable'].clearSelection();
      this.selectid='';
      this.selectdata.length=0;
      this.vbindData.querydata=[];
    },
    /**
     * 点击取消按钮，关闭弹出框
     */
    cancelSelect() {
      this.dialogVisible = false;
      // 清空已选的节点状态
      this.$refs['selectListTable'].clearSelection();
      this.selectid='';
      this.selectdata.length=0;
      this.vbindData.querydata=[];
    },
    /**
     * 关闭弹出框时保留所选状态
     */
    keepSelectState(){
      if(this.vbindData.querydata&&this.vbindData.querydata.length!=0){
        this.$nextTick(()=>{
          let selectIndexs=[];
          for(let i=0;i<this.vbindData.querydata.length;i++){
            let flag=false;
            for(let selectRow of this.selectdata){
              flag=this.isObjectValueEqual(this.vbindData.querydata[i], selectRow);
              if(flag){
                break;
              }
            }
            if(flag){
              selectIndexs.push(i);
            }
          }

          for(let selectIndex of selectIndexs){
            if(this.vbindData.selecttype=='radio'){
              this.$refs.selectListTable.setCurrentRow(this.vbindData.querydata[selectIndex]);
            }else{
              this.$refs.selectListTable.toggleRowSelection(this.vbindData.querydata[selectIndex],true);
            }
          }
        });
      }
    },
    /**
     * 判断两个不同对象，若其属性相同则相等
     */
    isObjectValueEqual(a, b) {
      var aProps = Object.keys(a);
      var bProps = Object.keys(b);

      let flag=true;
      if (aProps.length != bProps.length) {
        flag= false;
      }
      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
          flag= false;
        }
      }
      return flag;
    },
    /**
     * 复选时的点击事件
     */
    selectPluralDataClick(vals, row) {
      //存储已选数据
      if(this.selectdata.length==0){
        this.selectdata.push(row);
      }else{
        let flag=false;
        for(let i=0;i<this.selectdata.length;i++){
          flag=this.isObjectValueEqual(row, this.selectdata[i]);
          if(flag){
            this.selectdata.splice(i, 1);
            break;
          }
        }
        if(!flag){
          this.selectdata.push(row);
        }
      }

      let selectid=''
      for(let selectVal of this.selectdata){
        if(selectid==''){
          selectid=selectVal[this.vbindData.configinfo.selectid];
        }else{
          selectid=selectid+','+selectVal[this.vbindData.configinfo.selectid];
        }
      }
      this.selectid=selectid;
    },
    /**
     * 单选时的点击事件
     */
    selectSingleDataClick(row) {
      if(this.isNotNullOrEmpty(row)){
        //存储已选数据
        this.selectdata.length=0;
        this.selectdata.push(row);

        let selectid=''
        for(let selectVal of this.selectdata){
          if(selectid==''){
            selectid=selectVal[this.vbindData.configinfo.selectid];
          }else{
            selectid=selectid+','+selectVal[this.vbindData.configinfo.selectid];
          }
        }
        this.selectid=selectid;
      }
    },
    /**
     * 当用户手动勾选全选 Checkbox 时触发的事件
     */
    selectAll(selection){
      
      if(selection.length==0){
        this.selectdata.length=0;
        this.selectid='';
      }else{
        let selectid='';
        for(let selectVal of selection){
          if(selectid==''){
            selectid=selectVal[this.vbindData.configinfo.selectid];
          }else{
            selectid=selectid+','+selectVal[this.vbindData.configinfo.selectid];
          }
        }
        this.selectid=selectid;
        this.selectdata=[...selection];
      }
    },
     /**
     * 点击查询，搜索信息
     */
    doQuery(){
      this.initData();
      console.log('2019年10月18日09:29:05 ListSelect.vue[描述]——[this.pagecond] :',this.pagecond);
    },
    /**
     * 点击重置，重置查询框的信息
     */
    resetQuery(){
        Object.keys(this.pagecond).forEach(key => this.pagecond[key] = '');
		},
	openModel() {
        this.setDialogPos();
    }
  },
  computed: {
    readonly: function () {
      if(this.editItem.indexOf(';'+this.matchItem+';')===-1){
        return false;
      }else{
        //若编辑域有该值则显示
        return true;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/SelectHrBankListInfo.vue